<template>
  <v-container class="loadCommunications-main" id="load-communication-container"
    ><v-form ref="form" v-model="valid" class="generic-box">
      <loading
        v-if="isLoading"
        :showLoading="true"
        class="loading-component"
      ></loading>

      <div class="main-div" v-if="showRequest">
        <div class="selector">
          <span
            class="create-com"
            :class="[createCom ? 'selected' : 'not-selected']"
            @click="selectMode(true)"
            >{{ $t("Communications.create") }}</span
          ><span
            :class="[!createCom ? 'selected' : 'not-selected']"
            @click="selectMode(false)"
            >{{ $t("Communications.communicationsHystory") }}</span
          >
        </div>

        <div class="generic-button-div" v-if="!showPreview">
          <v-btn class="generic-button right" @click="back">{{
            $t("Misc.back")
          }}</v-btn>
        </div>

        <!-- communication -->
        <div v-if="createCom" class="body">
          <div v-if="!showPreview">
            <div class="load-doc">
              <span>{{ $t("Communications.loadDocuments") }}</span>
            </div>
            <div>
              <v-btn class="generic-button top-margin" @click="LoadDocument">{{
                $t("Misc.add")
              }}</v-btn>
            </div>
            <div class="file-load top-margin">
              <input
                ref="uploader"
                class="d-none"
                type="file"
                multiple="multiple"
                @change="onFileChanged"
                accept=".pdf"
              />
              <div
                v-for="(selectedFile, index) in selectedFiles"
                :key="index"
                :item="selectedFile"
              >
                <div class="fileInput">
                  <div class="fileName">{{ selectedFile.name }}</div>
                  <div @click="removeFile(selectedFile)">
                    <span class="span">{{
                      $t("Communications.removeFile")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedFiles.length == 0" class="error-div">
              {{ $t("Communications.attachmentsMandatory") }}
            </div>
            <div class="title-text">{{ $t("Communications.title") }}</div>
            <div class="title-text">
              <v-text-field
                filled
                rounded
                dense
                no-resize
                single-line
                v-model="title"
                color="#6f767a4d"
                class="top-margin"
                :label="$t('Communications.title_text')"
                required
                :rules="[rules.mandatoryRule]"
              ></v-text-field>
            </div>
            <div class="top-margin">{{ $t("Communications.division") }}</div>
            <div class="checkboxed">
              <v-row>
                <v-checkbox
                  class="checkbox"
                  v-model="cAll"
                  :label="$t('Communications.all')"
                  @change="allSelected"
                  :rules="[rules.checkboxRuleAll]"
                ></v-checkbox>
                <v-checkbox
                  class="checkbox"
                  v-model="cTransport"
                  :label="$t('Divisions.Transport')"
                  @change="oneSelected"
                  :rules="[rules.checkboxRuleTransport]"
                ></v-checkbox>
                <v-checkbox
                  class="checkbox"
                  v-model="cDistribution"
                  :label="$t('Divisions.Distribution')"
                  @change="oneSelected"
                  :rules="[rules.checkboxRuleDistribution]"
                ></v-checkbox>
                <v-checkbox
                  class="checkbox"
                  v-model="cAirOcean"
                  :label="$t('Divisions.AirOcean')"
                  @change="oneSelected"
                  :rules="[rules.checkboxRuleAirOcean]"
                ></v-checkbox>
                <v-checkbox
                  class="checkbox"
                  v-model="cLog"
                  :label="$t('Divisions.Logistics')"
                  @change="oneSelected"
                  :rules="[rules.checkboxRuleLog]"
                ></v-checkbox>
                <v-checkbox
                  class="checkbox"
                  v-model="cSpecialService"
                  :label="$t('Divisions.SpecialServices')"
                  @change="oneSelected"
                  :rules="[rules.checkboxRuleSpecialServices]"
                ></v-checkbox>
              </v-row>
            </div>
            <div class="top-margin">{{ $t("Communications.description") }}</div>
            <div class="textarea">
              <v-textarea
                v-model="description"
                no-resize
                single-line
                height="200"
                required
                :rules="[rules.mandatoryRule]"
              ></v-textarea>
            </div>
            <div class="top-margin">{{ $t("Communications.accept") }}</div>
            <div class="accept">
              <v-checkbox
                class="checkbox"
                v-model="accept"
                :label="$t('Communications.mandatory')"
              ></v-checkbox>
              <div class="buttons">
                <v-btn class="generic-button first" @click="previewDocument">{{
                  $t("Communications.preview")
                }}</v-btn>
                <v-btn class="generic-button" @click="saveDocument">{{
                  $t("Communications.send")
                }}</v-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="history-div" v-if="showHistory">
          <communication-list></communication-list>
        </div>

        <!-- preview -->
        <div class="communication-preview" v-if="showPreview">
          <communication
            class="preview"
            :title="title"
            :description="description"
            :isPreview="true"
          ></communication>
          <div class="buttons-div">
            <!-- <v-btn
              class="generic-button first"
              @click="downloadCommunication"
              >{{ $t("Communications.download") }}</v-btn
            > -->
            <v-btn class="generic-button" @click="editCommunication">{{
              $t("Communications.edit")
            }}</v-btn>
          </div>
        </div>
      </div>

      <div class="communication-sent" v-if="showSuccess">
        <div class="img-container">
          <img src="@/assets/check_Tavola.png" class="check-img" />
        </div>
        <div class="msg-container">
          {{ $t("Communications.communicationSaved") }}
        </div>
        <div class="button-div">
          <v-btn class="generic-button" @click="clearRequest()">
            {{ $t("Communications.uploadAnotherCommunication") }}
          </v-btn>
        </div>
        <div class="span-div">
          <span @click="showRequestAfterSave">
            {{ $t("Communications.showHystory") }}
          </span>
        </div>
      </div>
    </v-form>
  </v-container>
</template>
<style>
/* communication-preview */
.container.loadCommunications-main .communication-preview .buttons-div {
  margin-top: 43px;
  text-align: right;
}

.container.loadCommunications-main .preview {
  border: solid 1px;
  border-radius: 0px 0px 20px 20px;
  margin-top: 60px;
}

.container.loadCommunications-main
  .communication-preview
  .buttons-div
  .generic-button.first {
  margin-right: 46px;
}

.container.loadCommunications-main
  .communication-preview
  .communication-component
  .main-title {
  font: normal normal normal 20px/24px Helvetica Neue;
  text-decoration: underline;
}

.container.loadCommunications-main
  .communication-preview
  .communication-component.preview {
  padding-left: 45px;
  padding-right: 45px;
}

/* communication saved */
.container.loadCommunications-main .communication-sent .img-container,
.container.loadCommunications-main .communication-sent .msg-container,
.container.loadCommunications-main .communication-sent .button-div,
.container.loadCommunications-main .communication-sent .span-div {
  text-align: center;
}

.container.loadCommunications-main .communication-sent .button-div {
  padding-top: 73px;
  padding-bottom: 33px;
}

.container.loadCommunications-main .communication-sent .span-div {
  padding-bottom: 33px;
}

.container.loadCommunications-main .communication-sent .span-div span {
  text-decoration: underline;
  font: normal normal normal 20px/24px Lato;
}

.container.loadCommunications-main .main-div {
  padding: 46px 54px 46px 54px;
}

.container.loadCommunications-main .create-com {
  padding-right: 40px;
}

.container.loadCommunications-main .selected {
  font: normal normal bold 20px/24px Roboto !important;
  text-decoration: underline;
}

.container.loadCommunications-main .not-selected {
  font: normal normal normal 20px/24px Roboto !important;
  text-decoration: none;
}

.container.loadCommunications-main span {
  cursor: pointer;
}

.container.loadCommunications-main .load-doc {
  margin-top: 28px;
}

.container.loadCommunications-main .top-margin {
  margin-top: 20px;
}

.container.loadCommunications-main .file-load {
  /* margin-top: 22px; */
  width: 485px;
}

.container.loadCommunications-main .file-load .v-text-field {
  padding: 0px;
  margin: 0px;
}

.container.loadCommunications-main .v-text-field {
  width: 485px;
  /* margin-top: 22px; */
  font: normal normal normal 16px/19px Roboto !important;
}

.container.loadCommunications-main .title-text .v-text-field .v-input__slot {
  background-color: #6f767a4d;
}

.container.loadCommunications-main
  .theme--light.v-input:not(.v-input--is-disabled)
  input {
  color: #707070 !important;
  /* margin: 0; */
  max-height: 30px;
}

.container.loadCommunications-main .theme--light.v-input:not {
  min-height: 30px;
}

.container.loadCommunications-main
  .v-text-field--filled.v-text-field--single-line
  input {
  margin-top: 6px;
}

.container.loadCommunications-main
  .container.loadCommunications-main
  .v-text-field--rounded
  > .v-input__control
  > .v-input__slot {
  min-height: 30px;
  max-height: 30px;
}

.container.loadCommunications-main
  .v-text-field--rounded
  > .v-input__control
  > .v-input__slot {
  min-height: 40px;
  max-height: 40px;
}

.container.loadCommunications-main .v-text-field--filled .v-label,
.v-text-field--full-width .v-label {
  top: 11px;
}

.container.loadCommunications-main
  .v-text-field--rounded
  > .v-input__control
  > .v-input__slot {
  border-radius: 20px;
}

.container.loadCommunications-main .row {
  margin: 0px;
}

.container.loadCommunications-main .checkbox {
  padding-right: 20px;
}

.container.loadCommunications-main .textarea .v-input,
.container.loadCommunications-main .textarea .v-input .v-input__control,
.container.loadCommunications-main
  .textarea
  .v-input
  .v-input__control
  .v-input__slot {
  height: 100% !important;
}

.container.loadCommunications-main .textarea,
.no-commercial-box-container .textarea {
  border-radius: 40px;
  background-color: #6f767a4d;
  margin-top: 16px;
}

.container.loadCommunications-main .textarea .v-label a,
.container.loadCommunications-main
  .theme--light.v-input:not(.v-input--is-disabled)
  textarea
  .no-commercial-box-container
  .v-label.theme--light {
  font: normal normal normal 16px/19px Lato;
  color: #707070;
  height: 100% !important;
}

.container.loadCommunications-main textarea,
.container.loadCommunications-main .textarea .v-label.theme--light {
  font: normal normal normal 20px Roboto;
  color: #707070 !important;
}

.container.loadCommunications-main
  .textarea
  .v-input.v-textarea.v-textarea--no-resize.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted {
  padding: 20px;
}

.container.loadCommunications-main .textarea .v-input--selection-controls {
  margin-top: 0px;
}

.container.loadCommunications-main
  .textarea
  .v-text-field
  > .v-input__control
  > .v-input__slot:before,
.container.loadCommunications-main
  .textarea
  .v-text-field
  > .v-input__control
  > .v-input__slot:after {
  border: unset !important;
}

.container.loadCommunications-main .accept .checkbox label {
  font: normal normal normal 16px/19px Lato;
  text-decoration: underline;
}

.container.loadCommunications-main .accept {
  display: flex;
}

.container.loadCommunications-main .accept .buttons {
  margin-left: auto;
}

.container.loadCommunications-main .accept .buttons .first {
  margin-right: 40px;
}

.container.loadCommunications-main .load-doc .generic-button {
  float: right;
}

.container.loadCommunications-main .fileInput {
  font: normal normal normal 16px/19px Lato;
  width: 485px;
  border-bottom: solid 1px;
  margin-bottom: 22px;
  display: flex;
  position: relative;
}

.container.loadCommunications-main .fileInput .span {
  position: absolute;
  right: 0px;
}

.container.loadCommunications-main .fileInput span {
  text-decoration: underline;
}

.container.loadCommunications-main .fileInput .fileName {
  padding-bottom: 4px;
}

.container.loadCommunications-main .error-div,
.container.loadCommunications-main .v-messages__message {
  color: #f44336 !important;
  caret-color: #f44336 !important;
  font-size: 12px;
  margin-bottom: 22px;
  font-style: normal;
  font: normal normal normal 12px/19px Roboto;
}

.container.loadCommunications-main
  .textarea
  .v-input.v-textarea.v-textarea--no-resize.theme--light.v-text-field.v-text-field--single-line.v-text-field--is-booted {
  width: 100%;
}

.container.loadCommunications-main
  .v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot,
.container.loadCommunications-main .v-input__slot,
.container.loadCommunications-main .v-text-field__details {
  margin: 0 !important;
}

.container.loadCommunications-main .v-messages,
.container.loadCommunications-main .v-text-field__details {
  min-height: unset !important;
}

.loading-component {
  height: 470px;
  position: relative;
}

.loading-component
  .v-progress-circular.v-progress-circular--indeterminate.white--text {
  color: #6f767a !important;
}
</style>
<script>
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import HSApi from "../api/Hyperstorage/HSApi.js";
import communicationList from "../components/communicationList.vue";
import loading from "../components/loadingComponent.vue";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  components: {
    communicationList,
    loading,
  },

  computed: {
    communicationSelected: function () {
      return this.$store.getters.GET_communicationSelected;
    },
  },

  watch: {
    communicationSelected: {
      handler() {
        var communication = this.$store.getters.GET_communicationSelected;
        // console.log("com", communication);

        MyFercamApi.GetCommunication(communication.id).then((res) => {
            // console.log("GetCommunication", res.data);
          this.title = res.data[0].titolo;
          this.description = res.data[0].descrizione;
          this.id = communication.id;
          this.mapToDivisionsCheckboxes(communication.idDivisioni);

          this.hsFiles = [];
          res.data.forEach((element) => {
            if (element.fileGuid) {
              this.hsFiles.push({
                fileguid: element.fileGuid,
                filename: element.filename,
              });

              HSApi.Download(element.fileGuid).then((hsres) => {
                // console.log("get pdf", hsres.data);

                this.selectedFiles.push(
                  new File([hsres.data], element.filename, {
                    type: "pdf",
                    lastModified: new Date(),
                  })
                );
              });
            }
          });
          //   console.log("hsFile", this.hsFiles);
          this.previewDocument();
        });
      },
    },
  },

  data() {
    return {
      createCom: true,
      title: "",
      cAll: false,
      cTransport: false,
      cDistribution: false,
      cAirOcean: false,
      cLog: false,
      cSpecialService: false,
      description: "",
      accept: false,
      selectedFiles: [],
      valid: false,
      divisions: null,
      showSuccess: false,
      showRequest: true,
      showPreview: false,
      showHistory: false,
      id: null,
      user: null,
      hsFiles: [],
      isLoading: false,
      rules: {
        mandatoryRule: (value) => !!value || Trans.i18n.t("Misc.mandatory"),
        checkboxRuleAll: (value) =>
          !!value ||
          !!this.cTransport ||
          !!this.cDistribution ||
          !!this.cLog ||
          !!this.cSpecialService ||
          !!this.cAirOcean ||
          Trans.i18n.t("Misc.mandatory"),
        checkboxRuleTransport: (value) =>
          !!value ||
          !!this.cAll ||
          !!this.cDistribution ||
          !!this.cLog ||
          !!this.cSpecialService ||
          !!this.cAirOcean ||
          Trans.i18n.t("Misc.mandatory"),
        checkboxRuleDistribution: (value) =>
          !!value ||
          !!this.cAll ||
          !!this.cTransport ||
          !!this.cLog ||
          !!this.cSpecialService ||
          !!this.cAirOcean ||
          Trans.i18n.t("Misc.mandatory"),
        checkboxRuleLog: (value) =>
          !!value ||
          !!this.cAll ||
          !!this.cTransport ||
          !!this.cDistribution ||
          !!this.cSpecialService ||
          !!this.cAirOcean ||
          Trans.i18n.t("Misc.mandatory"),
        checkboxRuleAirOcean: (value) =>
          !!value ||
          !!this.cAll ||
          !!this.cTransport ||
          !!this.cLog ||
          !!this.cSpecialService ||
          !!this.cDistribution ||
          Trans.i18n.t("Misc.mandatory"),
        checkboxRuleSpecialServices: (value) =>
          !!value ||
          !!this.cAll ||
          !!this.cTransport ||
          !!this.cLog ||
          !!this.cDistribution ||
          !!this.cAirOcean ||
          Trans.i18n.t("Misc.mandatory"),
      },
    };
  },
  async created() {
    const isLoad = this.$route.params.isLoad;
    this.selectMode(isLoad);

    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      //console.log("username refresh: ", this.$GAUserAuth.user.username);

      this.user = this.$GAUserAuth.user;
      //   console.log("load doc user", this.user);
    });

    MyFercamApi.GetDivisions().then((res) => {
      //   console.log("res", res.data);
      this.divisions = res.data;
    });
  },
  methods: {
    selectMode(createCom) {
      //   console.log("mode", createCom);
      this.createCom = createCom;
      this.showHistory = !createCom;
      this.showPreview = false;
    },
    LoadDocument() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      // todo
      //   if (e.target.file.type != "application/pdf") {
      //     console.log("wrong file type");
      //     return;
      //   }

      for (var i = 0; i < e.target.files.length; i++) {
        this.selectedFiles.push(e.target.files[i]);
      }

      //   console.log("selectedfile", this.selectedFiles);
      // Do whatever you need with the file, liek reading it with FileReader
    },
    removeFile(file) {
      //   console.log("remove file", file);
      var newSelectedFiles = [];
      this.selectedFiles.forEach((selectedFile) => {
        // console.log("sel file", selectedFile);
        if (selectedFile.name != file.name) {
          newSelectedFiles.push(selectedFile);
        }
      });
      this.selectedFiles = newSelectedFiles;
      //   console.log("sel file", this.selectedFiles);
    },
    back() {
      router.push({ name: "admin" }).catch((err) => {
        this.close();
      });
    },
    allSelected() {
      this.cTransport = false;
      this.cDistribution = false;
      this.cAirOcean = false;
      this.cLog = false;
      this.cSpecialService = false;
    },
    oneSelected() {
      this.cAll = false;
    },
    clearRequest() {
      this.showSuccess = false;
      this.showRequest = true;
      this.clearItems();
      // console.log("clearRequest, this.id", this.id);
    },
    clearItems() {
      this.title = "";
      this.description = "";
      this.clearCheckboxes();
      this.selectedFiles = [];
      this.id = null;
      this.hsFiles = [];
    },
    clearCheckboxes() {
      this.accept = false;
      this.cAll = false;
      this.cTransport = false;
      this.cDistribution = false;
      this.cAirOcean = false;
      this.cLog = false;
      this.cSpecialService = false;
    },
    previewDocument() {
      this.showPreview = true;
      this.showHistory = false;
    },
    async downloadCommunication() {
      // update
      if (this.id) {
        if (this.hsFiles.length == 1) {
          HSApi.Download(this.hsFiles[0].fileguid).then((res) => {
            // console.log("download", res.data);
            saveAs(
              new Blob([res.data], { type: "application/pdf" }),
              this.hsFiles[0].filename
            );
          });
        } else if (this.hsFiles.length > 1) {
          let zip = await HSApi.DownloadZip(
            this.hsFiles.map((a) => a.fileguid)
          );

          saveAs(
            new Blob([zip.data], { type: "application/octet-stream" }),
            "package.zip"
          );
        }
      }
      // new
      else {
        if (this.selectedFiles.length == 1) {
          saveAs(
            new Blob([this.selectedFiles[0]], { type: "application/pdf" }),
            this.selectedFiles[0].name
          );
        } else if (this.selectedFiles.length > 1) {
          // todo: doesn't work
          var zip = new JSZip();
          for (let index = 0; index < this.selectedFiles.length; index++) {
            const element = this.selectedFiles[index];
            var res = await HSApi.Download(element.fileguid);
            // console.log("file", element.filename, [res]);
            zip.file(element.filename, [res], { binary: true });
            // zip.file(element.filename, Buffer.from([res]).toString("base64"), {
            //   binary: true,
            // });
          }

          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(
              new Blob([content], { type: "application/octet-stream" }),
              "example.zip"
            );
          });
        }
      }
    },
    editCommunication() {
      this.showPreview = false;
      // on preview edit land always on creation/edit container
      this.selectMode(true);
    },
    showRequestAfterSave() {
      this.clearItems();
      this.showRequest = true;
      this.showSuccess = false;
      this.selectMode(false);
    },
    mapToDivisionsCheckboxes(idDivisions) {
      this.clearCheckboxes();
      var ids = idDivisions.split(",");

      ids.forEach((element) => {
        this.getCheckboxByDivision(
          this.$genericClass.GetDivisionDB().filter((x) => x.id == element)[0]
            .name
        );
      });
    },
    getCheckboxByDivision(division) {
      if (division == "All") this.cAll = true;
      if (division == "Distribution") this.cDistribution = true;
      if (division == "Transport") this.cTransport = true;
      if (division == "AirOcean") this.cAirOcean = true;
      if (division == "Logistics") this.cLog = true;
      if (division == "SpecialServices") this.cSpecialService = true;
    },
    setIsLoading(isloading) {
      this.isLoading = isloading;
    },
    async saveDocument() {
      let user = this.$GAUserAuth.user;
      var isValid = this.$refs.form.validate() && this.selectedFiles.length > 0;
      //   console.log("isvalid", isValid);

      //   console.log(
      //     "divisions",
      //     this.divisions,
      //     this.divisions.filter((x) => x.descrizione == "Transport")[0].id
      //   );

      var divisions = [];
      if (this.cAll) {
        divisions.push(
          this.divisions.filter((x) => x.descrizione == "Tutte")[0].id
        );
      } else {
        if (this.cTransport) {
          divisions.push(
            this.divisions.filter((x) => x.descrizione == "Transport")[0].id
          );
        }
        if (this.cDistribution) {
          divisions.push(
            this.divisions.filter((x) => x.descrizione == "Distribution")[0].id
          );
        }
        if (this.cAirOcean) {
          divisions.push(
            this.divisions.filter((x) => x.descrizione == "Air & Ocean")[0].id
          );
        }
        if (this.cLog) {
          divisions.push(
            this.divisions.filter((x) => x.descrizione == "Logistics")[0].id
          );
        }
        if (this.cSpecialService) {
          divisions.push(
            this.divisions.filter((x) => x.descrizione == "Special Services")[0]
              .id
          );
        }
      }

      if (isValid) {
        var communication = {
          id: this.id,
          title: this.title,
          description: this.description,
          mandatory: this.accept,
          uploadUser: user.username,
          divisions: divisions,
        };

        this.setIsLoading(true);
        this.showRequest = false;

        // console.log("communcation to save", communication);

        // save communication
        var res = await MyFercamApi.SaveCommunication(communication);

        // console.log("save doc", res.data);

        this.$store.commit(
          "SET_communicationsUpdated",
          !this.$store.getters.GET_communicationsUpdated
        );

        var communicationId = this.id ? this.id : res.data;

        // delete hs files
        for (let index = 0; index < this.hsFiles.length; index++) {
          const element = this.hsFiles[index];
          var res = await HSApi.DeleteFull(
            element.fileguid,
            this.user.username
          );
        }

        // upload to hyperstorage
        for (let index = 0; index < this.selectedFiles.length; index++) {
          const element = this.selectedFiles[index];
          //   console.log("element", element);
          var reader = new FileReader();
          var fileByteArray = [];
          reader.readAsArrayBuffer(element);
          reader.onloadend = (evt) => {
            if (evt.target.readyState == FileReader.DONE) {
              var arrayBuffer = evt.target.result,
                array = new Uint8Array(arrayBuffer);
              for (var i = 0; i < array.length; i++) {
                fileByteArray.push(array[i]);
              }

              var fullFileUpload = {
                File: fileByteArray,
                MyFercamMetadata: { User: this.user.username },
                Metadata: {
                  RepoCode: process.env.VUE_APP_REPOCODE,
                  FileName: element.name.substr(
                    0,
                    element.name.lastIndexOf(".")
                  ),
                  Extension: "pdf",
                  Versioning: false,
                  CreationUser: this.user.username,
                  LastModifyUser: this.user.username,
                  Weight: fileByteArray.length,
                },
              };
              //   console.log("fullFileUpload", fullFileUpload);
              HSApi.UploadFull(fullFileUpload).then((res) => {
                // console.log("hsapi upload", res.data);
                var arg = {
                  communicationId: communicationId,
                  fileGuid: res.data.id,
                  filename: res.data.fileName,
                };
                MyFercamApi.SaveCommunicationDocument(arg).then((res) => {});

                if (index == this.selectedFiles.length - 1) {
                  //   console.log("## upload ended ##");
                  this.setIsLoading(false);
                  this.showSuccess = true;
                }
              });
            }
          };
        }
      }
    },
  },
};
</script>


